import type { Sheet } from "@fortune-sheet/core";
import { useQuery } from "@tanstack/react-query";
import { backendService } from "../../../services/backend.service";
import { excelBufferToFortuneSheet } from "../../../utils/excelToFortuneSheet";

type Params = {
	departmentId: string;
	locationName: string;
	startDate: string;
	endDate: string;
	enabled: boolean;
};

export const useFacilitySchedulePreview = ({ departmentId, locationName, startDate, endDate, enabled }: Params) => {
	return useQuery<Sheet[]>({
		queryKey: ["facility-schedule-preview", departmentId, locationName, startDate, endDate],
		queryFn: async () => {
			const response = await backendService.getFacilityScheduleDownload({
				departmentId,
				locationName,
				startDate,
				endDate,
			});
			return excelBufferToFortuneSheet(response.data as ArrayBuffer);
		},
		enabled,
	});
};
